import { render, staticRenderFns } from "./CompanyInformation.vue?vue&type=template&id=b799af44&scoped=true&"
import script from "./CompanyInformation.vue?vue&type=script&lang=js&"
export * from "./CompanyInformation.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInformation.vue?vue&type=style&index=0&id=b799af44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b799af44",
  null
  
)

export default component.exports